import React from "react";
import { Login } from "../../../components";
import { useTranslation } from "react-i18next";
import { MADERA_BACKOFFICE_PATHS } from "constants/constants";

export const OsornoBackofficeLogin = () => {
    const { t } = useTranslation();
    return (
        <Login
            title={t("login.madera-backoffice-login")}
            redirect={`/${MADERA_BACKOFFICE_PATHS.ROOT_PATH}/${MADERA_BACKOFFICE_PATHS.SETUP_DASHBOARD.ROOT}`}
        />
    );
};
